import React, {
  useEffect, useRef, useState,
} from 'react';

import { Typography } from '@mui/material';

import Button, { ButtonProps } from '../Button';

import { CheckIcon, CopyBlock } from './index.styles';

interface CopyButtonProps extends ButtonProps {
  copyText: string | (() => string),
  buttonLabel?: string,
  confirmationLabel?: string,
}

const CopyButton = ({ copyText, buttonLabel, confirmationLabel, variant = 'contained', ...rest }: CopyButtonProps) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [copyMsgVisibility, setCopyMsgVisibility] = useState<boolean>(false);
  const [width, setWidth] = useState<number>(0);
  const [height, setHeight] = useState<number>(0);

  useEffect(() => {
    if (buttonRef?.current?.offsetWidth) setWidth(buttonRef?.current?.offsetWidth);
    if (buttonRef?.current?.offsetHeight) setHeight(buttonRef?.current?.offsetHeight);
  }, [buttonRef.current]);

  return (
    copyMsgVisibility ? (
      <CopyBlock
        width={width}
        height={height}
      >
        <CheckIcon color="success" />
        {variant !== 'text' && (
          <Typography variant="overline" color="success.main">
            {confirmationLabel || 'COPIED'}
          </Typography>
        )}
      </CopyBlock>
    ) : (
      <Button
        buttonRef={buttonRef}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          navigator.clipboard.writeText(typeof copyText === 'function' ? copyText() : copyText);
          // Block copy button for 1 second, then re-render
          setCopyMsgVisibility(true);
          setTimeout(() => {
            setCopyMsgVisibility(false);
          }, 1000);
        }}
        {...rest}
        variant={variant}
      >
        {buttonLabel || 'Copy'}
      </Button>
    )
  );
};

export default CopyButton;
